export default "__VITE_ASSET__zfLH9jju__"